import React from 'react'
// import TipJar from '../components/tipjar/TipJar'

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import '../sytles/Card.css'

import img from '../images/example.png'

const useStyles = makeStyles({
    root: {
      minWidth: 275,
      backgroundColor: '#2d2b2b'
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
      color: 'white'
    },
    pos: {
      marginBottom: 12,
      color: 'white'
    },

  });
  
 const RuleCard = () => {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;
  
    return (
      <Card className={classes.root}>
        <CardContent>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            GoodLuck!
          </Typography>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {/* <TipJar /> */}
          </Typography>
          <Typography variant="h5" component="h2">
            B{bull}I{bull}N{bull}G{bull}O
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            Rules
          </Typography>
          <Typography  className={classes.pos} variant="body2" component="p">
            Connect 5 squares.
            <br />
            Diagonally, Vertically or Horizontally
            Each Square must have the codename printed in chat, example below
          </Typography>
        </CardContent>
        <CardActions>
            <img src={img} alt="example" />
        </CardActions>
      </Card>
    );
  }


export default RuleCard
